import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { CartProvider } from './Context/Cartcontext.jsx'
import { ClerkProvider } from '@clerk/clerk-react'
import { NavProvider } from './Context/NavContext'

const PUBLISHABLE_KEY = "pk_test_d29ya2FibGUtY29sbGllLTU4LmNsZXJrLmFjY291bnRzLmRldiQ"

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <CartProvider>
        <NavProvider>
          <App />
        </NavProvider>
      </CartProvider>
    </ClerkProvider>
  </StrictMode>,
)
